(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbAssignedUsers',[AssignedUsersDirective])
		.controller('AssignedUsersController', [
			AssignedUsersController
		]);

	var templateUrl = require('./assignedUsers.template');
	function AssignedUsersDirective() {
		return {
			restrict: 'E',
			controller: AssignedUsersController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				assignedUsers: '=',
				selectedUser: '=',
				isContentStatusSelected: '='
			}
		};
	}

	function AssignedUsersController() {
		var vm = this;
		vm.onChange = onChange;

		function onChange() {
			if (vm.selectedUser === '') {
				vm.selectedUser = undefined;
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/assignedUsers/assignedUsers.js
// module id = 63
// module chunks = 1